const manutencao_de_fase_origem_do_aluno = [
  {
    path: "/manutencao-de-fase-origem-do-aluno",
    redirect: "/manutencao-de-fase-origem-do-aluno",
    meta: {
      breadCrumb: "Gestão - Apoio Gerencial Gestão de Classe",
    },
    children: [
      {
        path: "/manutencao-de-fase-origem-do-aluno",
        name: "manutencao-de-fase-origem-do-aluno",
        component: () =>
          import(
            "@/views/ManutencaoDaFaseDeOrigemDoAluno/ManutencaoDaFaseDeOrigemDoAluno.vue"
          ),
      },
    ],
  },
];

export { manutencao_de_fase_origem_do_aluno };
